import styled from 'styled-components';
import { green, ocean } from '../utils/style/colors';

export const Container = styled('div')`
  max-width: 800px;
  margin: 10px auto;
  width: 100%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
`;
export const Descriptoin = styled('div')`
  display: block;
  position: relative;
  background: var(--exact-white);
  text-align: justify;
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  margin: 10px 10px;
  max-height: 4rem;
  text-overflow: ellipsis;
  white-space: pre-line;
  overflow: hidden;
  transition: max-height 1s ease;
  & > span {
    position: absolute;
    left: 10px;
    bottom: 1px;
    color: ${green};
    background-color: var(--exact-white);
  }
  :hover {
    max-height: 1000px;
    & > span {
      display: none;
    }
  }
  padding: 10px;
`;
export const DownContainer = styled('div')`
  max-width: 800px;
  min-width: 300px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;
export const ICUContainer = styled('div')`
  margin: 10px 10px 0px;
  min-height: 50px;
  padding: 8px;
  background: var(--exact-white);
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
`;
export const BedContainer = styled('div')`
  background: var(--exact-white);
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  margin: 10px 10px;
  width: 50%;
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 10px;
`;
interface ItemProps {
  bold: boolean;
}

export const Row = styled('div')<ItemProps>`
width: 100%;
display: flex
font-weight: ${(props) => (props.bold ? '500' : '300')}
color: ${(props) => (props.bold ? 'black' : 'gray')}
    justify-content: space-between;
`;
export const ItemTitle = styled('span')`
  font-size: 12px;
  line-height: 16px;
  margin: 10px;
`;
export const ItemValue = styled('span')`
  font-size: 12px;
  line-height: 16px;
  margin: 10px;
`;
export const ModalTitle = styled('span')`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  display: block;
  align-items: center;
  text-align: center;
  padding: 0 30px;
`;

export const ModalDescriptoin = styled('div')`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 24px;
  display: block;
  align-items: center;
  text-align: center;
`;

export const TableHeaderRow = styled('tr')`
  // display: flex;
  // flex-direction: row;
  // align-items: flex-end;
  padding: 12px 16px 12px 0px;
  border-radius: 10px;
  font-weight: 500;
  color: ${ocean};
`;
export const TableHeaderTitle = styled('th')`
  min-width: 150px;
  position: -webkit-sticky; /* for Safari */
  position: sticky !important;
  right: 0;
@media not all and (min-resolution:.001dpcm) { @supports (-webkit-appearance:none) { 
  right: unset !important;
 }
 }
    top:0
  z-index:2
  border-radius: 0 16px 16px 0 ;
  background: #f4f9f8;
`;
export const TableHeaderTitleValueText = styled('span')`
  background: rgba(0, 137, 123, 0.05);
  border-radius: 12px;
  padding: 3px 8px;
`;
interface TableHeaderTitleValueProps {
  last?: boolean;
}
export const TableHeaderTitleValue = styled('th')<TableHeaderTitleValueProps>`
  min-width: 50px;
    top:0
  z-index:1
    position: -webkit-sticky !important; /* for Safari */
  position: sticky !important;
  background: #f4f9f8;
  ${(props) => props.last && 'border-radius: 12px 0px 0px 12px;'}
  
    text-align: center;

`;
export const TableRow = styled('tr')`
  padding: 12px 16px 12px 0px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
`;
export const TableItemSubTitle = styled('span')`
  font-weight: 300;
  display:block
  font-size: 12px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.6);
`;
export const TableItemTitle = styled('th')`
  flex-grow: 1;
  min-width: 150px;
  position: -webkit-sticky; /* for Safari */
  position: sticky !important;
  font-weight: 300;
  font-size: 12px;
  line-height: 24px;
  right: 0;
  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) {
      right: unset !important;
    }
  }
  padding: 5px;
  background: var(--exact-white);
`;
export const TableItemValue = styled('td')`
  text-align: center;
`;
export const TableWrapper = styled('div')`
  width: 100%;
  max-width: 100%;
  max-height: calc(100vh - 250px);
  @media (max-width: 450px) {
    max-height: calc(100vh - 200px);
  }
  overflow: auto;
  overflow: overlay;
`;
export const TableHead = styled('thead')`
  border: 0;
`;
export const DaySelect = styled('div')`
  padding-bottom: 10px;
  overflow: auto;
  overflow: overlay;
  display: flex;
  justify-content: space-between;
`;

export const ImageSection = styled('div')`
  display: flex;
  max-width: 800px;
  margin: 10px 10px;
  flex-wrap: wrap;
  justify-content: space-between;
`;
export const ImageColumn = styled('div')`
  display: none;
  flex: 1;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: auto;
  padding: 5px;
  @media (max-width: 450px) {
    display: flex;
    flex-direction: column;
    max-width: 170px;
  }
`;
export const ImageRow = styled('div')`
  display: none;
  flex: 1;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (min-width: 450px) {
    display: flex;
    flex-direction: row;
  }
`;
export const ImageContainer = styled('div')`
  cursor: pointer;
  @media (min-width: 450px) {
    width: 115px;
  }
`;
export const ImageComponent = styled('img')`
  width: 100%;
  margin-bottom: 5px;
  @media (min-width: 450px) {
    height: 137px;
  }
`;
